module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-LEANLINK-0120-small-25f152ceec5dbbcfdbef7ec0a38dae0e.png";